import type { ChannelMiniEntity } from '@/features/channel/domain/entities/ChannelMiniEntity'
import type { RateType } from '../enums/RateType'
import type { OrderRateReasonTranslationEntity } from './OrderRateReasonTranslationEntity'

export class OrderRateReasonEntity {
  id?: number
  translations?: Array<OrderRateReasonTranslationEntity> | null
  minRate?: number
  maxRate?: number
  rateType?: RateType
  channel?: ChannelMiniEntity
}
